<!-- Modern Register User Component -->
<div class="register-user-container">
  <!-- User Header -->
  <div class="user-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="user-title">
          <i class="pi pi-user-plus"></i>
          Register New User
        </h1>
        <p class="user-subtitle">Create a new user account with appropriate permissions</p>
      </div>
      <div class="header-right">
        <div class="user-status">
          <i class="pi pi-info-circle status-icon"></i>
          <span>User Registration</span>
        </div>
      </div>
    </div>
  </div>

  <!-- User Content -->
  <div class="user-content">
    <form [formGroup]="userForm" (ngSubmit)="onSubmitUserForm()" class="user-form">
      
      <!-- Basic Information Section -->
      <div class="content-section">
        <div class="section-header">
          <h2 class="section-title">
            <i class="pi pi-user"></i>
            Basic Information
          </h2>
        </div>
        
        <div class="form-grid">
          <div class="form-field">
            <label for="first_name" class="form-label">
              <i class="pi pi-user"></i>
              First Name
            </label>
            <input
              id="first_name"
              type="text"
              class="modern-input"
              formControlName="first_name"
              placeholder="Enter first name"
            />
            <div *ngIf="submitted && userForm.get('first_name')?.errors" class="error-message">
              <p-message
                *ngIf="f && f['first_name'] && f['first_name'].errors && f['first_name'].errors['required']"
                severity="error"
                text="Please enter your first name"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label for="last_name" class="form-label">
              <i class="pi pi-user"></i>
              Last Name
            </label>
            <input
              id="last_name"
              type="text"
              class="modern-input"
              formControlName="last_name"
              placeholder="Enter last name"
            />
            <div *ngIf="submitted && userForm.get('last_name')?.errors" class="error-message">
              <p-message
                *ngIf="f && f['last_name'] && f['last_name'].errors && f['last_name'].errors['required']"
                severity="error"
                text="Please enter your last name"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label for="username" class="form-label">
              <i class="pi pi-at"></i>
              Username
            </label>
            <input
              id="username"
              type="text"
              class="modern-input"
              formControlName="username"
              placeholder="Enter username"
            />
            <div *ngIf="submitted && userForm.get('username')?.errors" class="error-message">
              <p-message
                *ngIf="f && f['username'] && f['username'].errors && f['username'].errors['required']"
                severity="error"
                text="Please enter a username"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label for="email" class="form-label">
              <i class="pi pi-envelope"></i>
              Email Address
            </label>
            <input
              id="email"
              type="email"
              class="modern-input"
              formControlName="email"
              placeholder="Enter email address"
            />
            <div *ngIf="submitted && userForm.get('email')?.errors" class="error-message">
              <p-message
                *ngIf="f && f['email'] && f['email'].errors && f['email'].errors['required']"
                severity="error"
                text="Please enter a valid email"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>
        </div>
      </div>

      <!-- Role and Permissions Section -->
      <div  class="content-section">
        <div class="section-header">
          <h2 class="section-title">
            <i class="pi pi-shield"></i>
            Roles and Permissions
          </h2>
        </div>
        
        <div class="form-grid">
          <div  class="form-field">
            <label for="role" class="form-label">
              <i class="pi pi-briefcase"></i>
              User Role
            </label>
            <p-dropdown
              inputId="role"
              [options]="roles"
              optionLabel="name"
              [(ngModel)]="selectedRole"
              optionValue="id"
              [showClear]="true"
              placeholder="Select a role"
              formControlName="role_id"
              (onChange)="onChange($event)"
              [disabled]="disabled"
              styleClass="modern-dropdown"
              appendTo="body"
            >
            </p-dropdown>
            <div *ngIf="submitted && userForm.get('role_id')?.errors" class="error-message">
              <p-message
                *ngIf="f && f['role_id'] && f['role_id'].errors && f['role_id'].errors['required']"
                severity="error"
                text="Please select a role"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div *ngIf="userRole != 'admin-switch' && userRole != 'hq-clinic-admin' && !data.formdata" class="form-field" formGroupName="customer">
            <label for="customer" class="form-label">
              <i class="pi pi-building"></i>
              Customer
            </label>
            <p-dropdown
              inputId="customer"
              [options]="customers"
              optionLabel="company_name"
              optionValue="id"
              [showClear]="true"
              placeholder="Select a customer"
              [(ngModel)]="selectedCustomer"
              formControlName="id"
              [virtualScroll]="true"
              [virtualScrollItemSize]="38"
              [filter]="true"
              filterBy="company_name"
              styleClass="modern-dropdown"
              appendTo="body"
            >
            </p-dropdown>
          </div>

          <div *ngIf="selectedRole == 14" class="form-field">
            <label for="webhook" class="form-label">
              <i class="pi pi-link"></i>
              Switch Webhook
            </label>
            <input
              id="webhook"
              type="text"
              class="modern-input"
              placeholder="https://example.com/scripting/"
              formControlName="webhook"
            />
          </div>
        </div>
      </div>

      <!-- Security Section -->
      <div class="content-section">
        <div class="section-header">
          <h2 class="section-title">
            <i class="pi pi-lock"></i>
            Security Settings
          </h2>
        </div>
        
        <div class="form-grid">
          <div class="form-field">
            <label for="password" class="form-label">
              <i class="pi pi-key"></i>
              Password
            </label>
            <input
              id="password"
              type="password"
              class="modern-input"
              formControlName="password"
              placeholder="Enter password"
            />
          </div>

          <div class="form-field">
            <label for="confirm_password" class="form-label">
              <i class="pi pi-key"></i>
              Confirm Password
            </label>
            <input
              id="confirm_password"
              type="password"
              class="modern-input"
              formControlName="confirm_password"
              placeholder="Confirm password"
            />
          </div>

          <div class="form-field password-status">
            <div *ngIf="userForm.errors?.['PasswordNoMatch'] && userForm.get('confirm_password')?.dirty" class="password-error">
              <i class="pi pi-exclamation-triangle"></i>
              <span>The passwords do not match</span>
            </div>
            <div *ngIf="!userForm.errors?.['PasswordNoMatch'] && userForm.get('confirm_password')?.dirty" class="password-success">
              <i class="pi pi-check-circle"></i>
              <span>The passwords match!</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Section -->
      <div class="action-section">
        <div class="action-buttons">
          <button
            type="submit"
            class="action-btn primary"
            [disabled]="loading"
          >
            <i class="pi pi-save"></i>
            <span *ngIf="!loading">Save Changes</span>
            <span *ngIf="loading">Saving...</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
